<template>
  <dv-border-box-12>
    <div class="item-container">
      <div
        v-show="activeType == 0"
        id="container"
        style="height: 100%; width: 100%"
      ></div>
      <!-- <div v-show="activeType == 1" id="flow-container"></div> -->
      <div class="images-container" v-show="activeType == 2">
        <div class="tab-images">
          <div v-for="item in imageList" :key="item.cameraSnapshotId">
            <div
              class="image-item"
              :title="item.organizationName + '(' + item.description + ')'"
              @click="imageClick(item)"
            >
              <img v-bind:src="item.imageUrl" />
              <div v-if="item.isOnline === false" class="image-online">
                离线
              </div>
              <div class="image-title">
                {{ item.organizationName }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="images-container" v-show="activeType == 3">
        <vxe-table
          show-overflow
          highlight-hover-row
          highlight-current-row
          auto-resize
          border="none"
          height="100%"
          :data="dynamicList"
          class="mytable-scrollbar"
          @cell-dblclick="delItemClick"
        >
          <vxe-table-column type="seq" width="60"></vxe-table-column>
          <vxe-table-column
            field="organizationName"
            width="300"
            title="企业名称"
            show-overflow="title"
          ></vxe-table-column>
          <vxe-table-column
            field="contactPerson"
            title="联系人"
            show-overflow="title"
          ></vxe-table-column>
          <vxe-table-column
            field="contactPhone"
            title="联系电话"
            show-overflow="title"
          ></vxe-table-column>
          <vxe-table-column
            field="in"
            title="入库量（kg）"
            show-overflow="title"
          ></vxe-table-column>
          <vxe-table-column
            field="out"
            title="出库量（kg）"
            show-overflow="title"
          ></vxe-table-column>
        </vxe-table>
      </div>
      <div class="btns">
        <button
          @click="changeMap(0)"
          :class="{ 'btn-active': activeType == 0 }"
        >
          企业分布
        </button>
        <button
          @click="changeMap(2)"
          :class="{ 'btn-active': activeType == 2 }"
        >
          企业监控
        </button>
        <!-- <button
          @click="changeMap(3)"
          :class="{ 'btn-active': activeType == 3 }"
        >
          库存动态<i v-show="isShowRedDot" class="red-dot"></i>
        </button> -->
      </div>
    </div>

    <vodal
      :show="isShowDetail"
      :width="1680"
      :height="800"
      :duration="300"
      :closeOnClickMask="false"
      animation="zoom"
      @hide="isShowDetail = false"
    >
      <Enterprise-Detail />
    </vodal>
  </dv-border-box-12>
</template>
<script>
/* eslint-disable */

import AMapLoader from "@amap/amap-jsapi-loader";
import remarkIcon from "../../assets/image/icon-marker1.png";
import remarkIcon2 from "../../assets/image/icon-marker2.png";
import remarkIcon3 from "../../assets/image/icon-marker3.png";
import remarkIcon4 from "../../assets/image/icon-marker4.png";
import remarkIcon5 from "../../assets/image/icon-marker5.png";
import remarkIconIn from "../../assets/image/icon-in.png";
import remarkIconOut from "../../assets/image/icon-out.png";

import alarmIcon from "../../assets/image/alarm.gif";
import EventBus from "../js/event-bus.js";
import EnterpriseDetail from "../dialog/EnterpriseDetail";
import Vodal from "../dialog/Vodal";
import layer from "layui-layer";
import * as echarts from "echarts";

export default {
  name: "EnterpriseMap",
  components: {
    Vodal,
    EnterpriseDetail,
  },
  data() {
    return {
      isShowRedDot: false,
      isShowDetail: false,
      currentOrgId: 0,
      activeType: 0,
      map: null,
      enterList: [],
      markers: [],
      imageList: [],
      dynamicList: [],
      i: 0,
      geoCoordMap: {
        福州: [119.4543, 25.9222],
        长春: [125.8154, 44.2584],
        重庆: [107.7539, 30.1904],
        西安: [109.1162, 34.2004],
        成都: [103.9526, 30.7617],
        常州: [119.4543, 31.5582],
        北京: [116.4551, 40.2539],
        北海: [109.314, 21.6211],
        海口: [110.3893, 19.8516],
        长沙: [113.019455, 28.200103],
        上海: [121.4, 31.73],
        内蒙古: [106.82, 39.67],
      },
      GZData: [
        [
          {
            name: "长沙",
          },
          {
            name: "福州",
            value: 95,
          },
        ],
        [
          {
            name: "长沙",
          },
          {
            name: "长春",
            value: 80,
          },
        ],
        [
          {
            name: "长沙",
          },
          {
            name: "重庆",
            value: 70,
          },
        ],
        [
          {
            name: "长沙",
          },
          {
            name: "西安",
            value: 60,
          },
        ],
        [
          {
            name: "长沙",
          },
          {
            name: "成都",
            value: 50,
          },
        ],
        [
          {
            name: "长沙",
          },
          {
            name: "常州",
            value: 40,
          },
        ],
        [
          {
            name: "长沙",
          },
          {
            name: "北京",
            value: 30,
          },
        ],
        [
          {
            name: "长沙",
          },
          {
            name: "北海",
            value: 20,
          },
        ],
        [
          {
            name: "长沙",
          },
          {
            name: "海口",
            value: 10,
          },
        ],
        [
          {
            name: "长沙",
          },
          {
            name: "上海",
            value: 80,
          },
        ],
        [
          {
            name: "长沙",
          },
          {
            name: "内蒙古",
            value: 80,
          },
        ],
      ],
    };
  },
  mounted() {

    EventBus.$on("enteriseClickEvent", (row) => {
      this.tempMarker(row, remarkIcon3);
    });

    EventBus.$on("enteriseDblClickEvent", (row) => {
      if (!row) {
        return;
      }
      this.showOrganizationDetail(row.organizationId);
    });

    EventBus.$on("showAlarmEvent", (row) => {
      if (!row) {
        return;
      }
      this.showOrganizationDetail(row.organizationId, 2);
    });
    // 加载地图;
    AMapLoader.load({
      key: "ec50f2ed47b6f23d3943dc96c6b25e1e",
      version: "1.4.15",
      plugins: ["AMap.DistrictSearch"],
    })
      .then((AMap) => {
        this.map = new AMap.Map("container");
        // 设置地图皮肤
        //this.map.setMapStyle("amap://styles/darkblue");
        this.map.setMapStyle("amap://styles/bc193faf8ad72aa1f9e13cc573025dec");

        // 加载地图中心点、缩放等级
        this.getMapConfig();
        this.getOrganizationsForMap();
        // 轮询更新marker状态
        // setInterval(() => {
        //   this.getOrganizationsForMap();
        // }, 30000);
      })
      .catch((e) => {
        console.log(e);
      });
  },
  methods: {
    delItemClick({ row }) {
      if (row) {
        this.showOrganizationDetail(row.organizationId);
      }
    },
    showOrganizationDetail(organizationId, tabIndex = 0) {
      this.isShowDetail = true;
      this.currentOrgId = organizationId;
      EventBus.$emit("showOrganizationDetail", organizationId, tabIndex);
    },
    changeMap(type) {
      this.activeType = type;
      if (type == 2) {
        this.getLastGroupByIoTDevice();
        // setTimeout(() => {
        //     // 危废流向
        //     this.drawMap();
        // }, 100);
      } else if (type == 3) {
        this.isShowRedDot = false;
        this.analyzeOrgInOut();
      }
    },
    tempMarker(data, icon) {
      if (!this.map || !data) {
        return;
      }
      var marker = new AMap.Marker({
        icon: icon,
        position: new AMap.LngLat(data.locationLng, data.locationLat),
        title: data.name,
        extData: data.organizationId,
      });
      // 鼠标点击marker弹出自定义的信息窗体
      AMap.event.addListener(marker, "click", () => {
        this.showOrganizationDetail(data.organizationId);
      });
      this.map.add(marker);

      setTimeout(() => {
        this.map.remove(marker);
      }, 60000);
    },
    addMarker(data, icon) {
      if (!this.map || !data) {
        return;
      }
      var title = "";
      if (data.isOnline === true) {
        title = data.name;
      } else {
        if (data.lastHeartbeatTime) {
          title = data.name + "(" + data.lastHeartbeatTime + ")";
        } else {
          title = data.name;
        }
      }
      var marker = new AMap.Marker({
        icon: icon,
        position: new AMap.LngLat(data.locationLng, data.locationLat),
        title: title,
        extData: data.organizationId,
      });
      // 鼠标点击marker弹出自定义的信息窗体
      AMap.event.addListener(marker, "click", () => {
        this.showOrganizationDetail(data.organizationId);
      });
      this.markers.push(marker);
      this.map.add(marker);
    },
    getMapConfig() {
      this.$api
        .getMapConfig()
        .then((result) => {
          if (result.ok === true) {
            this.map.setCenter([
              result.data.BIG_SCREEN_CENTER_LNG,
              result.data.BIG_SCREEN_CENTER_LAT,
            ]);
            this.map.setZoom(result.data.BIG_SCREEN_ZOOM);
          } else {
            console.log("请求失败!");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getOrganizationsForMap() {
      this.$api
        .getOrganizationsForMap()
        .then((result) => {
          if (result.ok === true) {
            if (result.data && result.data.length <= 0) {
              return;
            }
            result.data.forEach((x) => {
              var oldMarker = this.markers.find(
                (m) => m.extData === x.organizationId
              );
              if (oldMarker) {
                // 存在判断状态是否一致
                var item = this.enterList.find(
                  (t) => t.organizationId === x.organizationId
                );
                if (item && item.isOnline !== x.isOnline) {
                  // 从地图上移除
                  this.map.remove(oldMarker);
                  // 从数组中移除
                  var index = this.markers.indexOf(oldMarker);
                  if (index !== -1) {
                    this.markers.splice(index, 1);
                  }
                  // 添加marker
                  this.addMarker(
                    x,
                    x.isOnline === false ? remarkIcon5 : remarkIcon4
                  );
                }
              } else {
                // 不存在直接添加
                this.addMarker(
                  x,
                  x.isOnline === false ? remarkIcon5 : remarkIcon4
                );
              }
            });
            //this.i++;
          } else {
            console.log("请求失败!");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getLastGroupByIoTDevice() {
      this.$api
        .getLastGroupByIoTDevice(100)
        .then((result) => {
          if (result.ok === true) {
            this.imageList = result.data;
          } else {
            this.imageList = [];
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    analyzeOrgInOut() {
      this.$api
        .analyzeOrgInOut()
        .then((result) => {
          if (result.ok === true) {
            this.dynamicList = result.data;
          } else {
            this.dynamicList = [];
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    drawMap() {
      var color = ["#c5f80e"];
      var series = [];

      [["石家庄", this.GZData]].forEach((item, i) => {
        series.push(
          {
            name: item[0],
            type: "lines",
            zlevel: 2,
            symbol: ["none", "arrow"],
            symbolSize: 10,
            effect: {
              show: true,
              period: 6,
              trailLength: 0,
              symbol: "arrow",
              symbolSize: 5,
            },
            lineStyle: {
              normal: {
                color: color[i],
                width: 1,
                opacity: 0.6,
                curveness: 0.2,
              },
            },
            data: this.convertData(item[1]),
          },
          {
            name: item[0],
            type: "effectScatter",
            coordinateSystem: "geo",
            zlevel: 2,
            rippleEffect: {
              brushType: "stroke",
            },
            label: {
              normal: {
                show: true,
                position: "right",
                formatter: "{b}",
              },
            },
            symbolSize: function (val) {
              return val[2] / 8;
            },
            itemStyle: {
              normal: {
                color: color[i],
              },
            },
            data: item[1].map((dataItem) => {
              return {
                name: dataItem[1].name,
                value: this.geoCoordMap[dataItem[1].name].concat([
                  dataItem[1].value,
                ]),
              };
            }),
          }
        );
      });
      let myChart = echarts.init(document.getElementById("flow-container"));

      this.$axios
        .get("//dp-wfb.cdfirst.net/map/china-map.json")
        //.get("http://localhost:8080/map/china-map.json")
        .then((chinaJson) => {
          echarts.registerMap("china", chinaJson);
          myChart.setOption({
            tooltip: {
              trigger: "item",
            },
            geo: {
              map: "china",
              label: {
                emphasis: {
                  show: false,
                },
              },
              zoom: 1.25,
              roam: true,
              itemStyle: {
                normal: {
                  borderColor: "rgba(147, 235, 248, 1)",
                  borderWidth: 1,
                  areaColor: {
                    type: "radial",
                    x: 0.5,
                    y: 0.5,
                    r: 0.8,
                    colorStops: [
                      {
                        offset: 0,
                        color: "rgba(175,238,238, 0)", // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "rgba(47,79,79, .1)", // 100% 处的颜色
                      },
                    ],
                    globalCoord: false, // 缺省为 false
                  },
                  shadowColor: "rgba(128, 217, 248, 1)",
                  // shadowColor: 'rgba(255, 255, 255, 1)',
                  shadowOffsetX: -2,
                  shadowOffsetY: 2,
                  shadowBlur: 10,
                },
                emphasis: {
                  areaColor: "#389BB7",
                  borderWidth: 0,
                },
              },
            },
            series: series,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    convertData(data) {
      var res = [];
      for (var i = 0; i < data.length; i++) {
        var dataItem = data[i];
        var fromCoord = this.geoCoordMap[dataItem[0].name];
        var toCoord = this.geoCoordMap[dataItem[1].name];
        if (fromCoord && toCoord) {
          res.push({
            fromName: dataItem[0].name,
            toName: dataItem[1].name,
            coords: [fromCoord, toCoord],
          });
        }
      }
      return res;
    },
    imageClick(item) {
      this.$api
        .getWithToken(item.iotDeviceId)
        .then((result) => {
          if (result.ok === true) {
            layer.open({
              type: 2,
              title: false,
              closeBtn: true,
              shade: 0.8,
              scrollbar: false,
              skin: "dialog-bg-transparent",
              area: ["893px", "600px"],
              content: "/page/video.html",
              success: (layero, index) => {
                var iframeWin = window[layero.find("iframe")[0]["name"]];
                iframeWin.layerData({
                  serialNo: result.data.serialNo,
                  accessToken: result.data.accessToken,
                });
              },
            });
          } else {
            alert("获取监控数据失败！");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="less">
.btn-dot {
  position: relative;
  padding: 5px;
}
.red-dot {
  display: block;
  background: red;
  border-radius: 50%;
  width: 10px;
  height: 10px;
  top: -3px;
  right: 5px;
  position: absolute;
}

.images-container {
  width: 100%;
  height: 90%;
  margin-top: 50px;
  margin-bottom: 10px;

  .tab-images::-webkit-scrollbar {
    display: none;
  }

  .tab-images {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    height: 100%;
    overflow-y: scroll;

    .image-item {
      width: 170px;
      height: 120px;
      margin: 5px;
      position: relative;

      img {
        width: 100%;
        height: 100%;
        border-radius: 5px;
        border: 1px solid transparent;
      }

      img:hover {
        border: 1px solid #168fbe;
        cursor: pointer;
      }

      .image-title {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        position: absolute;
        z-index: 2;
        width: 90%;
        color: #cce2fc;
        font-size: 13px;
        margin: 10px;
        bottom: -5px;
      }

      .image-online {
        top: 10px;
        right: 10px;
        position: absolute;
        z-index: 2;
        color: #cc0000;
        font-size: 13px;
      }
    }
  }
}
.item-container {
  height: 100%;
  width: 100%;
  img {
    width: 17px;
  }

  #flow-container {
    position: absolute;
    height: 94%;
    width: 96%;
    top: 20px;
    left: 20px;
  }

  .card-item {
    position: relative;
    margin: 10px;
  }
  .card-item-img {
    position: absolute;
    top: 10px;
    right: 10px;
  }
  .card-item-title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-top: 50px;
    position: absolute;
    z-index: 2;
  }
}
.btn-active {
  background: url(../../assets/image/bg-btn-active.png) no-repeat !important;
}
</style>
